/* eslint-disable */
import React from "react";
import { Skeleton } from "@material-ui/lab";
import { orderBy } from "lodash";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';
import { CalendarHierarchy, InputCalendarHierarchyItem } from "../../../controls/CalendarHierarchy";
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { findClosestPrecedingDate, getDateParts } from "../utils/dateHelpers";

const MONTH_FREQUENCY = 4;
interface ControlItem extends HierarchyControlItem<number> {
  frequencyId: number;
}

export const CbotDateControl: React.FC = () => {
  const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);
  const [loadingValue, setLoadingValue] = React.useState<boolean>(true);
  const [cbotDateValue, setCbotDateValue] = useParameter<number>("@cbot_date");
  const [dictItems, dict, dictLoading] = useDictionary(dictionaryService, "slides-cbot-date-slide34");

  React.useEffect(function updateControlItems() {
    setLoadingValue(true);
    if (dictItems) {
      const sortedDictItems = orderBy(dictItems, (item) => item.getValue<number>("order"));
      const candiatesControlItems = sortedDictItems?.map<ControlItem>((item) => ({
        id: Number(item.id),
        parent: item.getValue<number>("parent"),
        name: item.getValue<string>("name") || "",
        frequencyId: item.getValue<number>("frequencyId")!,
      }));

      const nextControlItems: ControlItem[] = candiatesControlItems.reduce((result, item) => {
        if (item.frequencyId === MONTH_FREQUENCY) {
          result.push(item);
        }
        return result;
      }, [] as any[]);

      setControlItems(nextControlItems);
      setLoadingValue(false);
    }
  }, [dictItems]);

  React.useEffect(() => {
    if (controlItems.length && controlItems.every((item) => item.id !== cbotDateValue)) {
      const lastMonthParts = getDateParts(controlItems[controlItems.length - 1].id as number);
      const oneYearsBack = Number(
        `${lastMonthParts.frequency}${Number(lastMonthParts.year) - 1}${lastMonthParts.month}${lastMonthParts.day}`,
      );
      const newDate = findClosestPrecedingDate(oneYearsBack, controlItems.map((item) => item.id) as number[]);
      if (newDate) {
        setCbotDateValue(newDate);
      } else {
        setCbotDateValue(controlItems[0].id);
      }
    }
  }, [controlItems, cbotDateValue]);

  const handlerChange = React.useCallback(
    (value: number | undefined) => value && setCbotDateValue(value),
    [dictItems, setCbotDateValue],
  );

  const loading = loadingValue || dictLoading;

  return (
    <HierarchyControl
      loading={loading}
      label="CBOT date"
      value={cbotDateValue as number | undefined}
      onChange={handlerChange}
      items={controlItems}
    />
  );
};
